var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strage_wrapper"},[_c('div',{staticClass:"strage_box"},[_c('strageList',{attrs:{"strageData":_vm.strageData},on:{"loadMore":function($event){return _vm.loadMore('more')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }